import request from '@/utils/request'
// 登录注册修改验证码接口

export function guestLogin (data) {
    return request({
        url: 'notcheck/login/guest',
        method: 'post',
        data
    })
}

export function guestLoginNoCapture (data) {
    return request({
        url: 'notcheck/login/guest/nokaptcha',
        method: 'post',
        data
    })
}

export function mediaLogin (data) {
    return request({
        url: 'notcheck/login/media',
        method: 'post',
        data
    })
}

export function workerLogin (data) {
    return request({
        url: 'notcheck/login/worker',
        method: 'post',
        data
    })
}

export function guangzhouLogin (data) {
  return request({
    url: 'notcheck/login/guangzhou',
    method: 'post',
    data
  })
}

export function getInfo (data) {
    return request({
        url: 'info',
        method: 'post',
        data
    })
}

export function checkCode (data) {
    return request({
        url: 'notcheck/checkCode',
        method: 'post',
        data
    })
}

export function resetGuest (data) {
    return request({
        url: 'notcheck/reset/guest',
        method: 'post',
        data
    })
}

export function resetMedia (data) {
    return request({
        url: 'notcheck/reset/media',
        method: 'post',
        data
    })
}

export function resetWorker (data) {
    return request({
        url: 'notcheck/reset/worker',
        method: 'post',
        data
    })
}

export function resetGuangzhou (data) {
    return request({
        url: 'notcheck/reset/guangzhou',
        method: 'post',
        data
    })
}


export function passwordGuest (data) {
    return request({
        url: 'notcheck/reset/guest',
        method: 'put',
        data
    })
}

export function passwordMedia (data) {
    return request({
        url: 'notcheck/reset/media',
        method: 'put',
        data
    })
}

export function passwordWorker (data) {
    return request({
        url: 'notcheck/reset/worker',
        method: 'put',
        data
    })
}

export function passwordGuangzhou (data) {
    return request({
        url: 'notcheck/reset/guangzhou',
        method: 'put',
        data
    })
}

export function getQrcode (query) {
    return request({
        url: 'qrcode',
        method: 'get',
        params: query
    })
}
